<form [formGroup]="premieANW">
    <div *ngIf="betaaldePremieANW.length > 0">
        <div formArrayName="betaaldePremieANW">
            <div *ngFor="let item of betaaldePremieANW.controls; let j = index;"
                 [formGroupName]="j">
                <div class="row col-auto">
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="j === 0 ? 'Omschrijving ANW-verzekering' : ''"
                                                    class="custom-input-250"
                                                    formControlName="omschrijving"
                                                    id="omschrijvingANW"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="j === 0 ? 'Polisnummer' : ''"
                                                    class="custom-input-250"
                                                    formControlName="polisnummer"
                                                    id="polisnummerANW"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="j === 0 ? 'Bedrag' : ''"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button (click)="verwijderRijPremieANW(j)"
                                         [class]="j === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                         class="delete"
                                         icon="trash"
                                         iconType="light"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="betaaldePremieANW.length === 0">
        <snelstart-ui-button (click)="addRijLoonPremieANW()" class="snelstart-ui-button pb-3 " icon="plus"
                             type="link">Premie nabestaandenverzekering
        </snelstart-ui-button>
    </div>
    <div *ngIf="betaaldePremieANW.length > 0">
        <snelstart-ui-button (click)="addRijLoonPremieANW()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Premie nabestaandenverzekering toevoegen
        </snelstart-ui-button>
    </div>

</form>
